<template>
  <nav class="bg-primary-foreground sticky top-0 w-full h-[100px] z-50">
    <div class="container mx-auto flex items-center h-full px-4 relative">
      <!-- Back button -->
      <button
        v-if="route.name == 'dropoff'"
        class="flex items-center text-gray-700 hover:text-gray-900 absolute left-4 top-1/2 -translate-y-1/2"
        @click="handleBack"
      >
        <ArrowLeft class="w-8 h-8 p-1 bg-[#F5ECDF] rounded-full text-color-[#747171]" />
      </button>

      <!-- Centered Logo -->
      <div class="flex-1 flex justify-center ml-2">
        <img
          :src="resolvedLogo"
          :alt="logoAlt"
          class=" max-h-[95px] object-contain
"
        />
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import DefaultLogo from '@/assets/klevercape-brand.png'
import { ArrowLeft } from 'lucide-vue-next'
import { useStepIndicator } from '@/composables/useStepIndicator'
import { useRoute } from "vue-router"

// ✅ Props for dynamic logo with default fallback
const props = withDefaults(
  defineProps<{
    logo?: string
    logoAlt?: string
  }>(),
  {
    logo: DefaultLogo,
    logoAlt: "KleverCape Logo"
  }
)

const route = useRoute()
const { currentStep } = useStepIndicator();

const resolvedLogo = props.logo

const handleBack = () => {
  if (currentStep.value === 1) return
  currentStep.value--
}
</script>
